import Vue from 'vue';

const CREATE_ORDER_URL = '/order/';
const UPDATE_ORDER_URL = '/order/';
const GET_CLIENT_ORDER_URL = '/order/';
const GET_CLIENT_ORDERS_URL = '/order/client-orders';
const GET_CLIENT_ORDER_ITEMS_URL = '/order/client-order-items';
const GET_ORDERS_URL = '/order/orders';
const GET_ORDER_ITEMS_URL = '/order/order-items';
const UPDATE_ORDER_ITEMS_URL = '/order/order-items';
const ADD_ORDER_ITEMS_URL = '/order/add-items';
const REMOVE_ORDER_ITEM_URL = '/order/remove-item';
const INCREASE_ORDER_ITEM_URL = '/order/increase-item';
const DECREASE_ORDER_ITEM_URL = '/order/decrease-item';
const APPROVE_ORDERS_URL = '/order/approve';
const REJECT_ORDERS_URL = '/order/reject';
const MERGE_ORDERS_URL = '/order/merge';
const AUTO_CREATE_ORDER_URL = '/order/auto-create';

class OrderService {

    async create(data) {
        return await Vue.prototype.$axios.post(CREATE_ORDER_URL, data);
    }

    async autoCreate(clientId) {
        return await Vue.prototype.$axios.put(AUTO_CREATE_ORDER_URL, null, {params: {clientId: clientId}});
    }

    async update(data) {
        return await Vue.prototype.$axios.put(UPDATE_ORDER_URL, data);
    }

    async updateOrderItem(data) {
        return await Vue.prototype.$axios.put(UPDATE_ORDER_ITEMS_URL, data);
    }

    async addOrderItems(data) {
        return await Vue.prototype.$axios.put(ADD_ORDER_ITEMS_URL, data);
    }

    async removeOrderItem(data) {
        return await Vue.prototype.$axios.put(REMOVE_ORDER_ITEM_URL, data);
    }

    async increaseOrderItem(data) {
        return await Vue.prototype.$axios.put(INCREASE_ORDER_ITEM_URL, data);
    }

    async decreaseOrderItem(data) {
        return await Vue.prototype.$axios.put(DECREASE_ORDER_ITEM_URL, data);
    }

    async getClientOrder(clientId) {
        return await Vue.prototype.$axios.get(GET_CLIENT_ORDER_URL, {params: {clientId: clientId}});
    }

    async getClientOrders(data) {
        return await Vue.prototype.$axios.post(GET_CLIENT_ORDERS_URL, data);
    }

    async getClientOrderItems(clientId, orderId) {
        return await Vue.prototype.$axios.get(GET_CLIENT_ORDER_ITEMS_URL, {params: {clientId: clientId, orderId: orderId}});
    }

    async getOrders(data) {
        return await Vue.prototype.$axios.post(GET_ORDERS_URL, data);
    }

    async getOrderItems(orderId) {
        return await Vue.prototype.$axios.get(GET_ORDER_ITEMS_URL, {params: {orderId: orderId}});
    }

    async approve(orderId) {
        return await Vue.prototype.$axios.put(APPROVE_ORDERS_URL, null, {params: {orderId: orderId}});
    }

    async reject(orderId) {
        return await Vue.prototype.$axios.put(REJECT_ORDERS_URL, null, {params: {orderId: orderId}});
    }

    async merge(data) {
        return await Vue.prototype.$axios.put(MERGE_ORDERS_URL, data);
    }
}

export default new OrderService();
